import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { oauthRouteRef, rootRouteRef } from './routes';

export const authExtensionPlugin = createPlugin({
  id: 'appfolio-auth',
  routes: {
    root: rootRouteRef,
    oauth: oauthRouteRef,
  },
});

export const AuthRefreshRedirect = authExtensionPlugin.provide(
  createRoutableExtension({
    name: 'AuthRefreshRedirect',
    component: () =>
      import('./components/AuthRefreshRedirect').then(
        m => m.AuthRefreshRedirect,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ConsentPage = authExtensionPlugin.provide(
  createRoutableExtension({
    name: 'ConsentPage',
    component: () =>
      import('./components/ConsentPage').then(m => m.ConsentPage),
    mountPoint: oauthRouteRef,
  }),
);
